import Intercom from '@intercom/messenger-js-sdk';
import { vueEnv, inIframe } from '@/globals';

const init = (config = {}) => {
  const intercomId = config.app_id || vueEnv('intercom_id');

  if (!intercomId) {
    console.warn('Intercom initialized without id');
    return false;
  }

  if (inIframe) {
    console.log('not using intercom when in child context');
    return false;
  }

  Intercom({
    app_id: intercomId,
    hide_default_launcher: true,
    ...config,
  });

  return true;
};

export default { init };
